import _extends from "@babel/runtime/helpers/esm/extends";
import React, { useEffect, useState } from 'react';
import { Accordion, AccordionDetails, AccordionSummary, Box } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Typography from "../../atoms/Typography";
import colors from "../../theme/colors";
import Container from "../../atoms/Container";
import HtmlRenderer from "../../atoms/HtmlRenderer";
import GameShortDescription from "./GameShortDescription";
import BonusItems from "./BonusItems";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const EStoreProductDetailAboutGame = ({
  titleCompareEdition,
  gameShortDescription,
  contentBonus,
  htmlRender = false,
  description,
  pullData = false,
  isShow = true
}) => {
  const [descriptionRender, setDescriptionRender] = useState([]);
  const [dataDescription, setDataDescription] = useState('');
  const [expanded, setExpanded] = useState(isShow);
  useEffect(() => {
    setExpanded(isShow);
  }, [isShow]);
  useEffect(() => {
    if (description) {
      const sentence = description.split('[overview]');
      setDescriptionRender(sentence);
      setDataDescription(description);
    }
  }, [description]);
  return /*#__PURE__*/_jsxs(Box, {
    sx: {
      width: "100%",
      display: "flex",
      flexDirection: "column",
      paddingBottom: {
        xs: htmlRender ? "0px" : "40px",
        md: htmlRender ? "0px" : "80px"
      }
    },
    className: "content-compare-edition",
    children: [/*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsx(Box, {
        sx: {
          padding: {
            xs: "0px 16px",
            md: "0px"
          },
          marginBottom: "24px"
        },
        children: /*#__PURE__*/_jsx(Box, {
          sx: {
            width: "100%",
            position: "relative",
            "&::before": {
              position: "absolute",
              content: "' '",
              width: "100%",
              left: "0px",
              top: "0px",
              borderBottom: "1px solid #C1C1C1",
              opacity: "0.5"
            }
          }
        })
      })
    }), /*#__PURE__*/_jsxs(Accordion, {
      sx: {
        boxShadow: 'none',
        minHeight: 'unset',
        margin: "0px !important",
        backgroundColor: 'transparent',
        "&:before": {
          display: "none"
        },
        '& .MuiAccordionSummary-root': {
          minHeight: 'unset',
          margin: '0px',
          padding: '0px'
        },
        '& .MuiAccordionSummary-content': {
          margin: '0px'
        },
        '& .Mui-expanded': {
          minHeight: 'unset !important',
          '& .MuiAccordionSummary-content': {
            minHeight: 'unset',
            margin: '0px'
          }
        }
      },
      defaultExpanded: expanded,
      onClick: () => {
        setExpanded(!expanded);
      },
      children: [/*#__PURE__*/_jsx(Container, {
        children: /*#__PURE__*/_jsx(Box, {
          sx: {
            paddingBottom: expanded ? "0px" : "24px",
            transition: "all 0.2s"
          },
          children: /*#__PURE__*/_jsx(AccordionSummary, {
            expandIcon: /*#__PURE__*/_jsx(ExpandMoreIcon, {
              sx: {
                fill: colors.primary.bandaiNamcoBlack
              }
            }),
            "aria-controls": "panel1a-content",
            id: "panel1a-header",
            sx: {
              padding: {
                md: "0px !important",
                xs: "0px 16px !important"
              }
            },
            children: /*#__PURE__*/_jsx(Typography, {
              variant: "h5",
              sx: {
                color: colors.primary.bandaiNamcoBlack
              },
              children: /*#__PURE__*/_jsx(HtmlRenderer, {
                component: "div",
                value: titleCompareEdition
              })
            })
          })
        })
      }), /*#__PURE__*/_jsx(Box, {
        sx: {
          display: "flex"
        },
        children: /*#__PURE__*/_jsxs(AccordionDetails, {
          sx: {
            padding: "0px",
            width: "100%"
          },
          children: [!pullData && dataDescription && /*#__PURE__*/_jsx(Container, {
            children: /*#__PURE__*/_jsx(Box, {
              sx: {
                padding: {
                  xs: "0px 16px",
                  md: "0px"
                }
              },
              children: /*#__PURE__*/_jsx(Typography, {
                variant: "p6",
                sx: {
                  color: colors.neutral.neutral2,
                  '& h3': {
                    color: colors.primary.bandaiNamcoBlack,
                    fontSize: {
                      xs: '22px',
                      md: '24px'
                    },
                    lineHeight: {
                      xs: '28px',
                      md: '30px'
                    },
                    '&:first-child': {
                      marginTop: '0px'
                    }
                  },
                  '& h4, h5, h6, h1, h2, h3': {
                    color: colors.primary.bandaiNamcoBlack,
                    fontSize: {
                      xs: "18px",
                      md: "24px"
                    },
                    lineHeight: {
                      xs: "24px",
                      md: "30px"
                    },
                    marginTop: {
                      xs: "32px",
                      md: "60px"
                    }
                  },
                  '& p': {
                    padding: "0px",
                    margin: "0px"
                  },
                  "& img": {
                    width: "100%",
                    height: "auto",
                    margin: "24px 0px",
                    borderRadius: {
                      xs: "10px",
                      md: "20px"
                    }
                  }
                },
                children: /*#__PURE__*/_jsx(HtmlRenderer, {
                  component: "div",
                  value: dataDescription
                })
              })
            })
          }), !!descriptionRender?.[0] && pullData && /*#__PURE__*/_jsx(Container, {
            children: /*#__PURE__*/_jsx(Box, {
              sx: {
                padding: {
                  xs: "0px 16px",
                  md: "0px"
                }
              },
              children: !!descriptionRender?.[0] && /*#__PURE__*/_jsx(Typography, {
                variant: "p6",
                sx: {
                  color: colors.neutral.neutral2,
                  '& h3': {
                    color: colors.primary.bandaiNamcoBlack,
                    fontSize: {
                      xs: '22px',
                      md: '24px'
                    },
                    lineHeight: {
                      xs: '28px',
                      md: '30px'
                    },
                    '&:first-child': {
                      marginTop: '0px'
                    }
                  },
                  '&  h1, h2, h3, h4, h5, h6': {
                    color: colors.primary.bandaiNamcoBlack,
                    fontSize: {
                      xs: "18px",
                      md: "24px"
                    },
                    lineHeight: {
                      xs: "24px",
                      md: "30px"
                    },
                    marginTop: "32px",
                    marginBottom: "20px"
                  },
                  '& p': {
                    padding: "0px",
                    margin: "0px"
                  },
                  "& img": {
                    width: "100%",
                    height: "auto",
                    margin: "12px 0px",
                    borderRadius: {
                      xs: "10px",
                      md: "20px"
                    }
                  }
                },
                children: /*#__PURE__*/_jsx(HtmlRenderer, {
                  component: "div",
                  value: descriptionRender[0]
                })
              })
            })
          }), pullData && gameShortDescription?.title && gameShortDescription?.mainImage && /*#__PURE__*/_jsx(Box, {
            sx: {
              paddingTop: "32px"
            },
            children: htmlRender && /*#__PURE__*/_jsxs(Box, {
              sx: {
                width: "100%",
                display: "flex",
                flexDirection: "column"
              },
              children: [/*#__PURE__*/_jsx(GameShortDescription, _extends({}, gameShortDescription)), !!contentBonus?.listImg?.length && /*#__PURE__*/_jsx(BonusItems, _extends({}, contentBonus))]
            })
          }), !!descriptionRender?.[1] && pullData && /*#__PURE__*/_jsx(Container, {
            children: !!descriptionRender?.[1] && /*#__PURE__*/_jsx(Box, {
              sx: {
                padding: {
                  xs: "0px 16px",
                  md: "0px"
                }
              },
              children: /*#__PURE__*/_jsx(Typography, {
                variant: "p6",
                sx: {
                  color: colors.neutral.neutral2,
                  '& h3': {
                    color: colors.primary.bandaiNamcoBlack,
                    fontSize: {
                      xs: '22px',
                      md: '24px'
                    },
                    lineHeight: {
                      xs: '28px',
                      md: '30px'
                    },
                    '&:first-child': {
                      marginTop: '0px'
                    }
                  },
                  '& h1, h2, h3, h4, h5, h6': {
                    color: colors.primary.bandaiNamcoBlack,
                    fontSize: {
                      xs: "18px",
                      md: "24px"
                    },
                    lineHeight: {
                      xs: "24px",
                      md: "30px"
                    },
                    marginTop: "32px",
                    marginBottom: "20px"
                  },
                  '& p': {
                    padding: "0px",
                    margin: "0px"
                  }
                },
                children: /*#__PURE__*/_jsx(HtmlRenderer, {
                  component: "div",
                  value: descriptionRender[1]
                })
              })
            })
          })]
        })
      })]
    })]
  });
};
export default EStoreProductDetailAboutGame;